import { render, staticRenderFns } from "./careLevelsDialog.vue?vue&type=template&id=52250bfb&scoped=true"
import script from "./careLevelsDialog.ts?vue&type=script&lang=js&external"
export * from "./careLevelsDialog.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52250bfb",
  null
  
)

export default component.exports